export function parseRefIdFromTgStartParam(str) {
  if (!str) return null;
  const parts = str.split("_");

  for (const part of parts) {
    // разделяем по первому дефису
    const [key, value] = part.split("-", 2);
    if (key === "refId") {
      return Number(value);
    }
  }
}
